import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import logo from "./../assets/img/logo-white.png";
import { FaInstagram } from "react-icons/fa";

const MainFooter = () => {
    const navigate = useNavigate();

    const handleJobListClick = (e: React.MouseEvent) => {
        e.preventDefault();
        const token = localStorage.getItem("authToken");
        if (!token) {
            navigate("/login");
        } else {
            navigate("/lowongan-kerja");
        }
    }

    return (
        <div className="footer">
            <Container className="py-3">
                <Row className="align-items-center">
                    <Col>
                        <Row>
                            <Col xs={12} md={'auto'}>
                                <div className='text-white'><strong>© {new Date().getFullYear()} TEMA</strong></div>
                            </Col>
                            <Col xs={12} md>
                                <a href="/ketentuan-layanan">
                                    Ketentuan Layanan
                                </a>
                                <a href="/kebijakan-privasi" className="ms-3">
                                    Kebijakan Privasi
                                </a>
                                <a href="#" onClick={handleJobListClick} className="ms-3">
                                    Lowongan Kerja
                                </a>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={"auto"}>
                        <div className="text-white" style={{ fontSize: "13px" }}>
                            Member of PT Origin Magda Inovasi
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default MainFooter;
